export function formatPhoneNumberString(PhoneNumber, PhoneNumberExt, PhoneNumberType) {
  if (PhoneNumber) {
    if (PhoneNumberType === "Mobile") {
      return "Mobile: " + PhoneNumber.replace(/^(\d{3})(\d{3})(\d{1,10})$/, "($1) $2-$3");
    } else {
      var PhoneExtChecked = PhoneNumberExt ? " : " + PhoneNumberExt : "";
      return "Office: " + PhoneNumber.replace(/^(\d{3})(\d{3})(\d{1,10})$/, "($1) $2-$3") + PhoneExtChecked;
    }
  }
  return "";
}

export function formatBooleanAsString(boolean) {
  if (boolean === true) {
    return "Yes";
  }
  //If False or null, return No
  return "No";
}

export function ConvertEmptyToNA(input) {
  return input ? input : "N/A";
}

export function isMobile(screen) {
  if (screen.width <= 700) {
    return true;
  }
  return false;
}

export function isMobileScreen() {
  return window.innerWidth < 770;
}
